import React from 'react'
import styled from '@emotion/styled'

import { breakpoints } from '../../constants'
import { blueDark10 } from '../../constants/principles'

export default () => <StyledBlueDotDiv />

const StyledBlueDotDiv = styled.div`
  width: 16px;
  height: 16px;
  border: solid ${blueDark10} 5px;
  @media (min-width: ${breakpoints.mid}px) {
    width: 24px;
    height: 24px;
    border: solid ${blueDark10} 7px;
  }
  border-radius: 50%;
  margin: 0px 4px;
`
